"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Item = function (props) {
    var title = props.title, content = props.content, href = props.href, img = props.img, tabIndex = props.tabIndex, bindingNum = props.bindingNum, _a = props.extendProps, extendProps = _a === void 0 ? {} : _a, onClick = props.onClick, _b = props.rowSpan, rowSpan = _b === void 0 ? 3 : _b;
    var handleClick = function (data) {
        if (data.tabIndex !== undefined && data.bindingNum !== undefined && onClick) {
            onClick(data.tabIndex, data.bindingNum);
        }
    };
    return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)('list-container', {
            'row-span-2': rowSpan === 2,
        }) }, extendProps, { onClick: function () { return handleClick(props); } }), tabIndex !== undefined && bindingNum !== undefined ? (react_1.default.createElement("div", { className: (0, classnames_1.default)('list', {
            'list-row-2': rowSpan === 2,
        }) },
        react_1.default.createElement("p", { className: (0, classnames_1.default)('content', {
                'content-row-2': rowSpan === 2,
            }) },
            react_1.default.createElement("strong", { className: "title" }, title),
            react_1.default.createElement("span", { className: "desc" }, content)),
        react_1.default.createElement("span", { className: "right-bg" }),
        img && (react_1.default.createElement("img", { className: (0, classnames_1.default)('img', {
                'img-row-2': rowSpan === 2,
            }), src: img })))) : (react_1.default.createElement("a", __assign({ className: (0, classnames_1.default)('list', {
            'list-row-2': rowSpan === 2,
        }), href: href, target: "_blank", rel: "noreferrer" }, (extendProps || {})),
        react_1.default.createElement("p", { className: (0, classnames_1.default)('content', {
                'content-row-2': rowSpan === 2,
            }) },
            react_1.default.createElement("strong", { className: "title" }, title),
            react_1.default.createElement("span", { className: "desc" }, content)),
        react_1.default.createElement("span", { className: "right-bg" }),
        img && (react_1.default.createElement("img", { className: (0, classnames_1.default)('img', {
                'img-row-2': rowSpan === 2,
            }), src: img }))))));
};
exports.default = Item;
//# sourceMappingURL=Item.js.map